module.exports = __webpack_public_path__ + "images/jobs/cybersecuriteQualite.621fa9ea.jpg";